import { render, staticRenderFns } from "./popover-route-detail.vue?vue&type=template&id=61121afd&"
import script from "./popover-route-detail.vue?vue&type=script&lang=js&"
export * from "./popover-route-detail.vue?vue&type=script&lang=js&"
import style0 from "./popover-route-detail.vue?vue&type=style&index=0&id=61121afd&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports